import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'TOKEN_EXPIRED',
    'TOKEN_REVOKED',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // Fuel business rules (fuel.md); the web translates each code, with params.
    'NO_QUANTITY',
    'NON_POSITIVE_TOTAL',
    'LESS_JERRYCANS_EXCEED_TOTAL',
    'REVOLVING_BALANCE_REQUIRED',
    'DEBT_LIMIT_EXCEEDED',
    'VEHICLE_NOT_OF_DEBTOR',
    'WRONG_CLOSE_PASSWORD',
    'CLOSE_PASSWORD_NOT_SET',
    'CLOSE_TEMPORARILY_BLOCKED',
    'WRONG_OVERVIEW_PASSWORD',
    'OVERVIEW_PASSWORD_NOT_SET',
    'OVERVIEW_TEMPORARILY_BLOCKED',
    'SYSTEM_FROZEN',
    'ALREADY_DELIVERED',
    'NOT_DELIVERABLE',
    'MESSAGE_NOT_RETRYABLE',
    'WRONG_PASSWORD',
    'YEAR_PRECONDITION_FAILED',
    'CATEGORY_NOT_AVAILABLE',
    'PRODUCT_NOT_ALLOWED',
    'BRANCH_NOT_ALLOWED',
    'DEBTOR_BRANCH_MISMATCH',
    'SYSTEM_GROUP_PROTECTED',
    'ARCHIVE_READ_ONLY',
    // Fuel PDA (fuel-pda.md sections 3, 4.3, 5 and 6); the web translates each code.
    'PDA_NET_QUANTITY_NOT_POSITIVE',
    'PDA_CATEGORY_MISSING',
    'PDA_CUSTOMER_EXISTS',
    'PDA_TRANSACTION_NOT_FOUND',
    'PDA_NOT_A_SALE',
    'PDA_TRANSACTION_CANCELLED',
    'PDA_WHATSAPP_DISABLED',
    'FORBIDDEN_PRODUCT',
    'PURCHASE_ALREADY_PRICED',
    'NATIONALITY_NAME_EXISTS',
    // Purchase customer phone change (KAN-52, fuel-pda.md section 6.2).
    'PHONE_TAKEN',
    'PHONE_CHANGED',
    'CUSTOMERS_UNAVAILABLE',
    // A phone change Customers refused: the person is gone, or Fuel may not change it.
    'CUSTOMERS_CUSTOMER_NOT_FOUND',
    'CUSTOMERS_REFUSED',
    // Inventory count mode (fuel.md section 4.4); the web translates each code.
    'INVENTORY_MODE_ACTIVE',
    'NO_OPEN_SHIFT',
    'ALREADY_POSTED',
    'PENDING_NOT_COMPLETED',
    // Operator transaction lookup (fuel.md section 4.3).
    'INVALID_TRANSACTION_CODE',
    'TRANSACTION_NOT_FOUND',
    'TRANSACTION_CANCELLED',
    'WRONG_PRODUCT',
    'NO_ACTION_AVAILABLE',
    // PDA sale (fuel-pda.md section 4.5, KAN-37).
    'SALE_ALREADY_PRICED',
    'SALE_NOT_COMPLETED',
    // The shared phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10, fuel.md section 8.3).
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    // A saving API whose Idempotency-Key is bound to the full payload (customers.md section 10.4).
    'IDEMPOTENCY_CONFLICT',
    // A save refused while the outbox sends the same record's Customers call (customers.md 9.7).
    'CUSTOMERS_CALL_IN_FLIGHT',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map